/*
    Merrid Controls. Wszelkie prawa zastrzeżone.
    Plik zawiera kody Źródłowe będące własnością firmy Merrid Controls.
    Nie wolno ich rozpowszechniać w całości lub fragmentach bez wyraźnej zgody właściciela.
*/


import React, {useState} from "react";

import {NavLink} from "react-router-dom";


import {Col, Row} from "react-bootstrap";

import {AiFillDelete, GiConfirmed, MdCancel} from "react-icons/all";

import MONITORY_NOTE_INTERFACE from "@Services/Application/Interfaces/MonitoryNotes/MonitoryNote";


import arrivalIcon from "@Icons/arrival.png";
import arrivalActiveIcon from "@Icons/arrival_active.png";


type TerminalMonitoryNoteProps = {
    MONITORY_NOTE: MONITORY_NOTE_INTERFACE;
    monitoryNoteDeleteHandler: any;
    MONITORY_NOTE_INDEX?: number;
};


const MONTH_LABELS: any = {
    1: "Stycznia",
    2: "Lutego",
    3: "Marca",
    4: "Kwietnia",
    5: "Maja",
    6: "Czerwca",
    7: "Lipca",
    8: "Sierpnia",
    9: "Września",
    10: "Października",
    11: "Listopada",
    12: "Grudnia"
};


export const TerminalMonitoryNoteComponent: React.FC<TerminalMonitoryNoteProps> = ({
    MONITORY_NOTE, monitoryNoteDeleteHandler,
    MONITORY_NOTE_INDEX = -1
}): JSX.Element | null => {


    const [monitoryNoteDeleteStatus, setMonitoryNoteDeleteStatus] = useState<boolean>(false);


    if (!MONITORY_NOTE) return null;

    const {
        TransportNotificationNo: monitoryNoteId,
    } = MONITORY_NOTE;

    const noteProcessStartDate = new Date(MONITORY_NOTE?.ProcessStartDate || "");

    const noteProcessStartDateDay = noteProcessStartDate.getDate();
    const noteProcessStartDateMonth = noteProcessStartDate.getMonth() + 1;
    const noteProcessStartDateHour = noteProcessStartDate.getHours();
    const noteProcessStartDateMinutes = noteProcessStartDate.getMinutes();

    const timeToStart = Math.ceil((noteProcessStartDate.getTime() - (new Date()).getTime()) / 1000 / 60);

    const noteTrucks = [MONITORY_NOTE?.FrontTruckRegNo, MONITORY_NOTE?.RearTruckRegNo].filter((truck: any) => !!truck)


    const NOTE_SUBMIT_AVAILABILITY = timeToStart <= +(MONITORY_NOTE?.MinDelayForSubmit || 0) && !MONITORY_NOTE?.IsSubmitted && !!MONITORY_NOTE?.IsDetailed && new Date() <= new Date(noteProcessStartDate);


    return (
        <Col key={MONITORY_NOTE.TransportNotificationNo} xs={12} className={"monitory-notes-list-element-component monitory-notes-list-element" + (MONITORY_NOTE?.IsSubmitted ? " submitted" : "")}>
            <Row className={"monitory-note-list-element-content"}>

                <Col as={NavLink} to={`/awizacje/${monitoryNoteId}`} xs={8} className={"monitory-note-information"}>
                    <Row className={"monitory-note-information-content"}>
                        <Col xs={12} className={"monitory-note-process-start note-information"}>
                            {MONITORY_NOTE?.ProcessStartDate != undefined &&
                                <span className={"note-information-value"}>                                    
                                    <span className={"note-process-start-month"}>{noteProcessStartDateDay < 10 ? "0" : ""}{noteProcessStartDateDay}</span>
                                    <span className={"note-process-start-month"}>{MONTH_LABELS[noteProcessStartDateMonth]} </span>
                                    <span className={"note-process-start-hour"}>
                                        {noteProcessStartDateHour < 10 ? "0" : ""}{noteProcessStartDateHour}:{noteProcessStartDateMinutes < 10 ? "0" : ""}{noteProcessStartDateMinutes}
                                    </span>
                                </span>
                            }
                            {MONITORY_NOTE?.ProcessStartDate == undefined &&
                                <span className={"note-information-value"}>                                    
                                    <span className={"note-process-start-month"}>Data: brak</span>
                                    <span className={"note-process-start-hour"}>Godzina: brak</span>
                                </span>
                            }
                        </Col>
                        <Col xs={12} className={"monitory-note-terminal note-information"}>
                            <span className={"note-information-label"}>{`Awizacja`}: </span>
                            <span className={"note-information-value"}>{MONITORY_NOTE?.TransportNotificationNo}</span>
                        </Col>
                        <Col xs={12} className={"monitory-note-vehicles note-information"}>
                            <span className={"note-information-value"}>{noteTrucks.join(" / ")}</span>
                        </Col>
                        <Col xs={12} className={"monitory-note-terminal note-information"}>
                            <span className={"note-information-label"}>{`Baza paliw`}: </span>
                            <span className={"note-information-value"}>{MONITORY_NOTE?.TerminalNo || ""}</span>
                        </Col>
                    </Row>
                </Col>

                <Col xs={4} className={"monitory-note-actions"}>
                    <Row className={"monitory-note-actions-content"}>

                        {NOTE_SUBMIT_AVAILABILITY &&
	                    <Col xs={12} className={"monitory-note-declare-arrival monitory-note-action"}>
		                    <NavLink
			                    to={{
                                    pathname: "/awizacje/zglos-przybycie",
                                    state: {monitoryNoteId: MONITORY_NOTE?.TransportNotificationNo, terminalName: MONITORY_NOTE?.TerminalNo}
                                }}
			                    title={""}
		                    >
			                    <img src={MONITORY_NOTE_INDEX === 0 ? arrivalActiveIcon : arrivalIcon} alt={`Zgłoś przybycie`} />
			                    <span>{`Zgłoś przybycie`}</span>
		                    </NavLink>
	                    </Col>
                        }

                        {!MONITORY_NOTE?.IsSubmitted &&
	                    <Col xs={12} className={"monitory-note-delete monitory-note-action" + (timeToStart <= +(MONITORY_NOTE?.MinDelayForSubmit || 0) ? " arrival-possible" : "")}>
		                    <NavLink
			                    to={{
                                    pathname: "/awizacje/usun",
                                    state: {monitoryNoteId: MONITORY_NOTE?.TransportNotificationNo}
                                }}
			                    title={""}
		                    >
			                    <AiFillDelete />
		                    </NavLink>
	                    </Col>
                        }

                        {!!MONITORY_NOTE?.IsSubmitted &&
			            <Col xs={12} className={"monitory-note-submitted-status monitory-note-action"}>
				            <img src={arrivalIcon} alt={``} />
				            <span>{`Przedłożona`}</span>
			            </Col>
                        }

                    </Row>
                </Col>

            </Row>
        </Col>
    );

};


export default TerminalMonitoryNoteComponent;
